import React from 'react'

import { Loader } from '@percept/mui'

import { DefaultLayoutComponent, isNewLayoutApp } from './layout'

import { CampaignSetup } from 'components/CampaignSetup'

import { DefaultOrganisationRedirect } from './Organisation'

import { useActiveOrgEnvironment } from '../components/Organisation'

import { useDocumentTitle } from '@percept/hooks'

import { OrgUnitContext } from '@percept/app-components'


const CampaignSetupScreen = (): JSX.Element => {
  const { activePlatformUnit } = useActiveOrgEnvironment()

  useDocumentTitle({
    paths: [
      activePlatformUnit && activePlatformUnit.name,
      'Campaign Setup',
    ]
  })

  if( !activePlatformUnit ){
    return (
      <DefaultLayoutComponent>
        <Loader preset='fullscreen' />
      </DefaultLayoutComponent>
    )
  }

  return (
    <DefaultLayoutComponent>
      <OrgUnitContext.Provider value={activePlatformUnit}>
        <CampaignSetup />
      </OrgUnitContext.Provider>
    </DefaultLayoutComponent>
  )
}


export default (
  isNewLayoutApp ?
    CampaignSetupScreen :
    DefaultOrganisationRedirect // Ensure non-dashboard apps can't navigate to this route
)

